import React, { useState, useEffect } from 'react';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { grey } from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const URLShortener = () => {
  const [shortUrls, setShortUrls] = useState([]);
  const [longUrl, setLongUrl] = useState('');
  const [slug, setSlug] = useState('');
  const [shortUrl, setShortUrl] = useState(null);
  const [open, setOpen] = useState(false);
  const [urlToDelete, setUrlToDelete] = useState(null);

  const token = localStorage.getItem('isha_token');

  const axiosConfig = {
    headers: {
      'accept': 'application/json',
      'Authorization': token
    }
  };

  useEffect(() => {
    fetchShortUrls();
  }, []);

  const fetchShortUrls = () => {
    axios.get('/api/short-urls', axiosConfig)
    .then(res => setShortUrls(res.data.links))
    .catch(err => console.error(err));
  }

  const createShortUrl = (event) => {
    event.preventDefault();
    axios.post('/api/short-url', {
      longUrl: longUrl,
      slug: slug
    }, axiosConfig)
    .then(res => {
      setShortUrl(res.data.shortURL);
      fetchShortUrls();
      setLongUrl('');
      setSlug('');
    })
    .catch(err => console.error(err));
  }

  const handleOpen = (url) => {
    setUrlToDelete(url);
    setOpen(true);
  };

  const handleClose = () => {
    setUrlToDelete(null);
    setOpen(false);
  };

  const deleteShortUrl = () => {
    axios.delete(`/api/short-url/${urlToDelete.id}`, axiosConfig)
    .then(res => {
      fetchShortUrls();
      handleClose();
    })
    .catch(err => console.error(err));
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
      <h1>URL Shortener</h1>
      <Box sx={{ display: 'flex', flexDirection: 'row', p: 1, gap: 2 }}>
        <TextField label="Enter URL" value={longUrl} sx={{ width: '500px' }} onChange={e => setLongUrl(e.target.value)} required />
        <TextField label="Enter Slug" value={slug} onChange={e => setSlug(e.target.value)} required />
        <Button variant="contained" color="primary" onClick={createShortUrl}>Shorten</Button>
      </Box>
      {shortUrl && <p>Your Short URL: <a href={shortUrl}>{shortUrl}</a></p>}
      <h2>Your Shortened URLs:</h2>
      {shortUrls.map((url, index) => (
        <Box key={url.id} sx={{ backgroundColor: index % 2 === 0 ? grey[200] : "white", p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <div>
            <Typography variant="body1"><a href={url.shortURL}>{url.shortURL}</a></Typography>
            <Typography variant="body2" color="text.secondary">{url.originalURL}</Typography>
          </div>
          <IconButton color="error" onClick={() => handleOpen(url)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete https://l.mee6.xyz/{urlToDelete?.lcpath}?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={deleteShortUrl} color="primary">Confirm</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default URLShortener;
